import React from 'react';
import { artistInfo, images } from '../data/mock';
import { Music, ExternalLink } from 'lucide-react';

const MusicSection = () => {
  return (
    <section id="music" className="py-24 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full filter blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-400 rounded-full filter blur-[120px]"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="text-blue-400 text-sm font-medium uppercase tracking-widest border-b-2 border-blue-400 pb-2 flex items-center gap-2 justify-center">
              <Music size={16} />
              Meine Musik
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Jetzt auf
            <span className="block bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Spotify hören
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Entdecke meine neuesten Songs, Alben und exklusive Playlists. Überall verfügbar.
          </p>
        </div>

        {/* Spotify Embed */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-green-500 to-blue-500 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-1000"></div>
            <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                style={{ borderRadius: '12px' }}
                src={artistInfo.spotifyEmbedUrl}
                width="100%"
                height="380"
                frameBorder="0"
                allowFullScreen=""
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="Spotify Player"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Performance Images Gallery */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <div className="relative group overflow-hidden rounded-xl">
            <img
              src={images.performance1}
              alt="Laura Sommerfeld Live Performance"
              className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
              <p className="text-white font-medium">Live Performance 2024</p>
            </div>
          </div>
          
          <div className="relative group overflow-hidden rounded-xl">
            <img
              src={images.performance2}
              alt="Laura Sommerfeld Studio"
              className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
              <p className="text-white font-medium">Studio Session</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href={artistInfo.spotifyEmbedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full font-medium uppercase tracking-wider transition-all duration-300 hover:shadow-2xl hover:shadow-green-500/50 hover:scale-105"
          >
            <ExternalLink size={20} />
            Auf Spotify öffnen
          </a>
        </div>
      </div>
    </section>
  );
};

export default MusicSection;
